import { BaseResponse, request } from "@/lib/request";

export const getCreationInfo = async (
	creation_id: string,
): Promise<BaseResponse<any>> => {
	return request.get("/aifk/creation/info", {
		creation_id,
	});
};

export const listCreationComment = async (
	creation_id: string,
	page_num?: number,
	page_size?: number,
) => {
	return request.get("/aifk/creation/comment/list", {
		page_num,
		page_size,
		creation_id,
	});
};

export const publishCreationComment = async (
	creation_id: string,
	content: string,
	parent_comment_id?: string,
) => {
	return request.post("/aifk/creation/comment/publish", {
		creation_id,
		content,
		parent_comment_id,
	});
};

export const likeCreationComment = async (comment_id: string) => {
	return request.post("/aifk/creation/comment/like", {
		comment_id,
	});
};

export const undoLikeCreationComment = async (comment_id: string) => {
	return request.post("/aifk/creation/comment/undo_like", {
		comment_id,
	});
};

export const createDialogue = async (creation_id: string) => {
	return request.post("/aifk/dialogue/create", {
		creation_id,
	});
};

export const renameDialogue = async (dialogue_id: string, name: string) => {
	return request.post("/aifk/dialogue/rename", {
		dialogue_id,
		name,
	});
};

export const deleteDialogue = async (dialogue_id: string) => {
	return request.post("/aifk/dialogue/delete", {
		dialogue_id,
		name,
	});
};

export const listDialogue = async (creation_id: string) => {
	return request.get("/aifk/dialogue/list", {
		creation_id,
		page_num: 1,
		page_size: 100,
	});
};

export const addCreationScore = async (creation_id: string, score: number) => {
	return request.post("/aifk/creation/scoring", {
		creation_id,
		score,
	});
};

export const reportCreationView = async (creation_id: string) => {
	return request.post("/aifk/creation/view", {
		creation_id,
	});
};

export const getLatestEditTime = async (creation_id: string) => {
	return request.get("/aifk/creation/latest_edit_time", {
		creation_id,
	});
};

export const getShareDialogueInfo = async (share_id: string) => {
	return request.get("/aifk/dialogue/share/info", {
		share_id,
	});
};
